import { render, staticRenderFns } from "./RedeemedItem.vue?vue&type=template&id=4ad71cc2&scoped=true&"
import script from "./RedeemedItem.vue?vue&type=script&lang=js&"
export * from "./RedeemedItem.vue?vue&type=script&lang=js&"
import style0 from "./RedeemedItem.vue?vue&type=style&index=0&id=4ad71cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad71cc2",
  null
  
)

export default component.exports